import React from 'react'

import {createLargeSvgIcon} from './utils'

export default createLargeSvgIcon(
  <>
    <mask height="36" id="mask0" maskUnits="userSpaceOnUse" width="34" x="3" y="2">
      <path
        d="M5.71139 10.4051L17.2114 3.64036C18.9326 2.62788 21.0674 2.62788 22.7886 3.64036L34.2886 10.4051C35.9685 11.3932 37 13.1967 37 15.1457V24.8543C37 26.8033 35.9685 28.6068 34.2886 29.5949L22.7886 36.3596C21.0674 37.3721 18.9326 37.3721 17.2114 36.3596L5.71139 29.5949C4.03148 28.6068 3 26.8033 3 24.8543V15.1457C3 13.1967 4.03148 11.3932 5.71139 10.4051Z"
        fill="#C4C4C4"
      />
    </mask>
    <g mask="url(#mask0)">
      <path d="M20 2L3 12L20 22L37 12L20 2Z" fill="url(#paint0_linear)" />
      <path d="M3 27.9997V12L20 22V38L3 27.9997Z" fill="url(#paint1_radial)" />
      <path d="M37 28V12L20 22V38L37 28Z" fill="url(#paint2_radial)" />
      <path
        clipRule="evenodd"
        d="M11.2777 3.8512L29.5332 14.7058C30.4426 15.2466 31 16.2264 31 17.2844V36H26V20.1286C26 19.0705 25.4426 18.0907 24.5332 17.55L8.72229 8.14888L11.2777 3.8512Z"
        fill="url(#paint3_radial)"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear" x1="19.32" x2="20.4462" y1="3.08" y2="19.0049">
        <stop stopColor="#FFE7C2" />
        <stop offset="1" stopColor="#E3B673" />
      </linearGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(19.2562 36.7997) rotate(-130.069) scale(18.8168 17.6299)"
        gradientUnits="userSpaceOnUse"
        id="paint1_radial"
        r="1"
      >
        <stop stopColor="#CA8D32" />
        <stop offset="1" stopColor="#F2C888" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(15.4035 31.3997) rotate(-27.4023) scale(21.51 19.4387)"
        gradientUnits="userSpaceOnUse"
        id="paint2_radial"
        r="1"
      >
        <stop stopColor="#C4892F" />
        <stop offset="1" stopColor="#E6BE81" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(8.99988 8.50006) rotate(30.7627) scale(24.4387 17.8918)"
        gradientUnits="userSpaceOnUse"
        id="paint3_radial"
        r="1"
      >
        <stop stopColor="#FFF6E8" />
        <stop offset="0.677761" stopColor="#FFF9EF" />
        <stop offset="1" stopColor="#F0DBBC" />
      </radialGradient>
    </defs>
  </>,
  'Delivery',
)
